module.exports = __webpack_public_path__ + "static/img/1.6f6da5bb.jpg";